// src/components/search/TopSearches.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { base_url } from '../utils/config';
import toast from 'react-hot-toast';

const TopSearches = () => {
  const [terms, setTerms] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTopSearches = async () => {
      try {
        const res = await fetch(
          `${base_url}/api/search-activity/top?limit=10`
        );
        if (!res.ok) throw new Error('Failed to load top searches');
        const { top } = await res.json();
        setTerms(top);
      } catch (err) {
        console.error(err);
        toast.error('Could not load top searches');
      } finally {
        setLoading(false);
      }
    };

    fetchTopSearches();
  }, []);

  if (loading) {
    return (
      <div className="py-4 text-center text-gray-500">
        Loading top searches…
      </div>
    );
  }

  if (terms.length === 0) {
    return (
      <div className="py-4 text-center text-gray-500">
        No top searches yet.
      </div>
    );
  }

  return (
    <div className="px-4 py-3">
      <h2 className="text-lg font-semibold mb-2">Top Searches</h2>
      <div className="flex flex-wrap gap-2">
        {terms.map(({ searchTerm }) => (
          <span
            key={searchTerm}
            onClick={() =>
              navigate(`/shops?search=${encodeURIComponent(searchTerm)}`)
            }
            className="cursor-pointer bg-gray-100 text-gray-800 px-3 py-1 rounded-full hover:bg-gray-200"
          >
            {searchTerm}
          </span>
        ))}
      </div>
    </div>
  );
};

export default TopSearches;
